import { trimEnd } from 'lodash';
import URI from '@wix/communities-forum-client-commons/dist/src/services/urijs';

export default (path, sectionUrl) => {
  const url = new URI(sectionUrl || '');
  url.pathname(trimEnd(url.pathname(), '/') + path);
  return url.toString();
};
